module.exports = __webpack_public_path__ + "img/ipyapp.cbca3a06.png";